
import { Lock, Shield, CheckCircle } from "lucide-react";

interface SecurityBadgeProps {
  variant?: "default" | "compact" | "detailed";
}

const SecurityBadge = ({ variant = "default" }: SecurityBadgeProps) => {
  if (variant === "compact") {
    return (
      <div className="inline-flex items-center gap-1 text-xs text-green-700 bg-green-50 px-2 py-1 rounded">
        <Lock className="w-3 h-3" />
        Secure
      </div>
    );
  }

  if (variant === "detailed") {
    return (
      <div className="bg-green-50 border border-green-200 rounded-lg p-4 space-y-2">
        <div className="flex items-center gap-2 text-green-800 font-medium">
          <Shield className="w-5 h-5" />
          Payment Security Features
        </div>
        <div className="space-y-1 text-sm text-green-700">
          <div className="flex items-center gap-2">
            <CheckCircle className="w-4 h-4" />
            <span>256-bit SSL encryption</span>
          </div>
          <div className="flex items-center gap-2">
            <CheckCircle className="w-4 h-4" />
            <span>PCI DSS compliant</span>
          </div>
          <div className="flex items-center gap-2">
            <CheckCircle className="w-4 h-4" />
            <span>Stripe secure processing</span>
          </div>
          <div className="flex items-center gap-2">
            <CheckCircle className="w-4 h-4" />
            <span>No card data stored locally</span>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="flex items-center gap-2 p-3 bg-green-50 border border-green-200 rounded-lg">
      <Lock className="w-4 h-4 text-green-600" />
      <Shield className="w-4 h-4 text-green-600" />
      <span className="text-sm text-green-800 font-medium">
        Secure Payment Processing
      </span>
    </div>
  );
};

export default SecurityBadge;
